import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { STRING } from '../../types';
import { UPLOAD_TYPE } from '../../upload-file/upload-file.component';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { forkJoin, Observable } from 'rxjs';

@Component({
	selector: 'app-upload',
	templateUrl: './upload.component.html',
	styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
	downloadText: string;
	labelClass: any;
	inputClass: any = [];
	rowClass: any;
	uploadOnSelect: boolean;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	visible = true;
	dropdownClass = 'col-md-0';
	showSlider = false;
	sliderImageUrls = [];
	uploadInputClass = 'col-md-12';
	UPLOAD_TYPE = UPLOAD_TYPE;
	// selectedCategory: string = STRING.EMPTY;
	private _categorisedValue: any = {};
	set categorisedValue(categorisedValue) {
		this._categorisedValue = categorisedValue;
	}
	get categorisedValue() {
		return this._categorisedValue;
	}
	@Input() tableLabel = {
		sno: 'S.NO',
		categoryName: 'S.No',
		file: 'File Name',
		action: 'Action'
	};
	@Input() categorisedFileDetails = [];
	@Input() isMultiSelect = false;
	@Input() isReviewRequiredSelect = false;
	@Input() formElement: any;
	@Input() formValue?: any;
	@Input() localFile: any;
	@Input() info: any;
	@Input() label: any;
	@Input() value: any;
	@Input() disabled = false;
	@Input() required: boolean;
	@Input() localFileValue: any;
	@Output() valueChange = new EventEmitter();
	@Output() localFileChange = new EventEmitter();
	@Input()
	allowedFormats = [
		STRING.PDF,
		STRING.JPEG,
		STRING.PNG,
		STRING.JPG,
		STRING.DOCX,
		STRING.XLSX
	];
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	@Output()
	blur = new EventEmitter<{
		name: string;
		value: any;
	}>();

	uploadedImageURL: any

	constructor(
		private fileService: FileService
	) { }

	// private _formatView() {
	// 	this.labelClass = ['col-form-label field-label'];
	// 	this.inputClass = [];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	this.rowClass = ['form-group'];
	// 	// this.rowClass = ['form-group', 'm-form__group'];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		this.isMultiSelect = this.formElement.multi;
	// 		derivedLabelClass.push('col-md-4');
	// 		derivedInputClass.push('col-md-8');
	// 	} else {
	// 		derivedLabelClass.push('col-md-2');
	// 		derivedInputClass.push('col-md-10');
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	if (labelDiv && inputDiv) {
	// 		derivedLabelClass = [`col-md-${labelDiv}`];
	// 		derivedInputClass = [`col-md-${inputDiv}`];
	// 	}
	// 	if (this.formElement.row) {
	// 		derivedLabelClass.push('right-text');
	// 		this.rowClass.push('row');
	// 	} else {
	// 		derivedLabelClass = ['col-md-12'];
	// 		derivedInputClass = ['col-md-12'];
	// 	}
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// }

	private _formatView() {

		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
		// this.dropdownClass = `col-md-${this.formElement.dropdownDiv}`;
		this.dropdownClass = 'col-md-0';
		// this.uploadInputClass = `col-md-${12 - this.formElement.dropdownDiv}`;
		this.uploadInputClass = 'col-md-12';
	}

	onFormValueChange(val) {
		// this.categorisedValue[this.selectedCategory] = val;
		if (val === null) {
			// this.resetInput();
		}
		if (this.value === val) {
			return;
		}
		if (val === STRING.EMPTY) {
			this.formElement.value = STRING.EMPTY;
		}
	}

	download(fileURL) {
		this.fileService.downloadAttachedFile(fileURL);
	}

	previewAllCategoryImages() {
		const downloadUrls = this.categorisedFileDetails.reduce((all, current) => {
			all = all.concat(current.downloadUrls);
			return all;
		}, [])
		const imageUrlsRequest = downloadUrls.map(url => this.fileService.getImageURL(url));
		forkJoin(imageUrlsRequest).subscribe((res: any) => {
			this.sliderImageUrls = res;
			this.showSlider = true;
		})
	}

	previewImages(category) {
		this.sliderImageUrls = [];
		console.log(category);
		const downloadUrls = category.downloadUrls;
		const imageUrlsRequest = downloadUrls.map(url => this.fileService.getImageURL(url));
		forkJoin(imageUrlsRequest).subscribe((res: any) => {
			this.sliderImageUrls = res;
			this.showSlider = true;
		})
	}

	resetInput() {
		this.visible = false;
		setTimeout(() => this.visible = true);
	}

	private mapfilesToCategoriseFile() {
		const categories = Object.keys(this.value);
		this.categorisedFileDetails = categories.map(category => {
			return {
				name: category,
				fileDetails: (this.value[category] || []).map(fileName => ({
					name: Helpers.deriveNameFromS3Url(fileName)
				})),
				fileNames: (this.value[category] || []).map(Helpers.deriveNameFromS3Url),
				downloadUrls: (this.value[category] || [])
			}
		})
	}

	ngOnInit() {
		let string;
		if (this.formElement.label.endsWith(':')) {
			string = this.formElement.label.slice(0, -1);
		}
		this.downloadText = `Download ${string ? string : ''}`;
		if (this.formValue) {
			this.formValue.valueChanges.subscribe(val => this.onFormValueChange(val));
			if (this.forDownload) {
				this.formValue.setValue(this.value);
			}
		}
		this.uploadOnSelect = this.formElement.uploadOnSelect;
		const viewImage = this.formElement.viewImage
		if (this.formElement) {
			this.info = this.formElement.info;
			this._formatView();
		}
		if (this.forDownload && this.formElement.uploadType === UPLOAD_TYPE.CATEGORISED) {
			this.mapfilesToCategoriseFile();
		}
	}

	onLocalFileChange() {
		this.localFileChange.emit(this.localFile);
	}

	get isCategorised() {
		return this.formElement.categories && this.formElement.categories.length && true;
	}

	onChange() {
		const value = this.value;
		// const value = this.isCategorised ? this.categorisedValue : this.value;
		this.valueChange.emit(value);
		this.change.emit({
			name: this.formElement.name,
			value: value
		});
		this.getDownloadedURL(this.value);
	}

	// onCategoryChange() {
	// 	if (this.selectedCategory) {
	// 		this.value = this.categorisedValue[this.selectedCategory];
	// 	}
	// 	console.log(this.selectedCategory)
	// }

	onBlur() {
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	get multiselect() {
		return this.isMultiSelect ? STRING.EMPTY : null;
	}

	get isReviewRequired() {
		return this.isReviewRequiredSelect ? STRING.EMPTY : null
	}

	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

	isCategoryDisabled() {
		return null;
	}

	get forDownload() {
		return (
			// !(this.formElement.uploadType === UPLOAD_TYPE.CATEGORISED) &&
			this.disabled || this.formElement.readOnly) ? true : false;
	}

	get imageView() {
		return this.formElement.viewImage ? true : false;
	}

	get disAllow() {
		return false;
		// return (this.formElement.categories &&
		// 		this.formElement.categories.length &&
		// 		this.selectedCategory === STRING.EMPTY) ? true : false;
	}

	getDownloadedURL(url) {
		this.fileService.getImageURL(url).subscribe((uploadedUrl: any) => {
			this.uploadedImageURL = uploadedUrl
		})
	}
}
